import * as React from "react";
import { Checkbox, Icon, Popup } from "semantic-ui-react";
import PlayerCardField from "./Fields/PlayerCardField";
import { URLS } from "../../../../../utils";
import { SocialNetworksId } from "../../../../../interfaces";
import { PolymorphicPlayerCard } from "../../../../../services/bedrock";
import { useFormContext } from "react-hook-form";
import { useContext } from "react";
import { PlayerCardSettingsContext } from "../../../Contexts";

interface SocialMediaWidgetSettingsProps {
  index: number;
}

const SocialMediaWidgetSettings: React.FC<SocialMediaWidgetSettingsProps> = ({ index }) => {
  const { getValues } = useFormContext<PolymorphicPlayerCard>();
  const {
    SocialNetworkSettings: { socialNetworkSettings },
    User,
  } = useContext(PlayerCardSettingsContext);

  const getSocialNetworkCheckbox = (networkId: SocialNetworksId) => {
    const settings = socialNetworkSettings[networkId];
    if (!settings?.isPermitted) return null;

    const mappings: { [key: string]: "Facebook" | "Instagram" | "LinkedIn" | "X" | "TikTok" | "Google" | "Zillow" } = {
      FB: "Facebook",
      IG: "Instagram",
      LI: "LinkedIn",
      TW: "X",
      TT: "TikTok",
      GL: "Google",
      ZL: "Zillow",
    };
    const socialNetwork = mappings[networkId];
    if (!socialNetwork) return null;

    const isConnected = !!settings.socialNetwork;
    const isToggled = getValues(`widgets.${index}.owner.display${socialNetwork}`);

    const getWarning = () => {
      if (isConnected || !isToggled) return null;
      var content: JSX.Element;
      if (User.isCoach) {
        content = <p>{socialNetwork} will not be displayed until the Player has connected it in their settings.</p>;
      } else {
        content = (
          <p>
            {socialNetwork} will not be displayed until it has been connected in your{" "}
            <a href={URLS.player.settingsSocialNetworks} target="_blank">
              settings
            </a>
          </p>
        );
      }

      return (
        <Popup
          position="right center"
          hoverable
          content={content}
          trigger={<Icon name="warning circle" color="yellow" />}
        />
      );
    };

    return (
      <div className="socialNetworkCheckbox">
        <PlayerCardField
          index={index}
          fieldName={`display${socialNetwork}`}
          fieldLabel={`Display ${socialNetwork} Link?`}
          component={Checkbox}
          toggle
        />
        {getWarning()}
      </div>
    );
  };

  return (
    <div className="playerCardWidgetOwner playerCardSocialMedia">
      {getSocialNetworkCheckbox("FB")}
      {getSocialNetworkCheckbox("IG")}
      {getSocialNetworkCheckbox("LI")}
      {getSocialNetworkCheckbox("TW")}
      {getSocialNetworkCheckbox("TT")}
      {getSocialNetworkCheckbox("GL")}
      {getSocialNetworkCheckbox("ZL")}
    </div>
  );
};
export default SocialMediaWidgetSettings;
